import {IRootState, RootState} from '../root-state.store';
// @ts-ignore
import {IApartmentService} from '@/services';
// @ts-ignore
import {ActivityStatus} from '@/common/enums';
import {ApartmentService} from '../../services/apartment.service';
import {
  ApartmentDto,
  ApartmentListingViewModel,
  ApartmentParameter,
  IApartment,
  IApartmentListingViewModel,
  IApartmentParameter
} from '../../models/apartment';
import {IPagination, Pagination} from '../../models/generic';
import {CrudStatus} from "../../common/enums";

export interface IApartmentState extends IRootState<IApartmentService> {
  apartments?: IApartmentListingViewModel[];
  sidebarApartments?: IApartmentListingViewModel[];
  currentApartment?: IApartmentListingViewModel;
  currentApartmentZone?: any[];
  apartment?: IApartment;
  pagination?: IPagination;
  apartmentParameter?: IApartmentParameter;
  currentBlockId?: string | null;
  zoneAction?: CrudStatus;
}

export class AppartmentState extends RootState<IApartmentService> implements IApartmentState {
  /**
   *
   */
  apartments?: IApartmentListingViewModel[];
  sidebarApartments?: IApartmentListingViewModel[];
  currentApartment?: IApartmentListingViewModel;
  currentApartmentZone?: any[];
  apartment?: IApartment;
  pagination?: IPagination
  apartmentParameter: IApartmentParameter;
  currentBlockId?: string | null;
  zoneAction?: CrudStatus;

  constructor() {
    super({ activityStatus: ActivityStatus.NoActivity });
    this.service = new ApartmentService;
    this.apartments = null;
    this.pagination = new Pagination({ total: 0, skip: 0, limit: 20 });
    this.currentApartment = new ApartmentListingViewModel;
    this.currentApartmentZone = [];
    this.apartment= new ApartmentDto
    this.apartmentParameter = new ApartmentParameter({ $limit: 20, key: '' });
    this.sidebarApartments = [];
    this.currentBlockId = null;
    this.zoneAction = CrudStatus.NoAction
  }
}



// WEBPACK FOOTER //
// ./src/store/apartment/apartment-state.store.ts